import { buildPath, getParamsMap } from './params';

export const convertToURL = (template, params) => {
  const [method, path] = template.split(' ');

  const paramsMap = getParamsMap(params);
  const urlPath = buildPath(path, paramsMap);

  if (method === 'GET') {
    path
      .split('/')
      .filter((el) => el.includes(':'))
      .forEach((key) => {
        paramsMap.delete(key.replace(':', ''));
      });
    return { method, urlPath, getParams: Object.fromEntries(paramsMap) };
  }

  return { method, urlPath };
};
